import { render, staticRenderFns } from "./EmployeeAddressInfo.vue?vue&type=template&id=fb4380a2&scoped=true"
import script from "./EmployeeAddressInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeAddressInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAddressInfo.vue?vue&type=style&index=0&id=fb4380a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4380a2",
  null
  
)

export default component.exports